module.exports = __webpack_public_path__ + "static/media/search.8087192b.svg";